import { useEffect, useState } from 'react';

import dayjs, { Dayjs } from 'dayjs';

interface CountdownValue {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

const getDiff = (target: Dayjs): CountdownValue => {
  const diff = target.diff(dayjs());

  if (diff <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  }

  const totalSeconds = Math.floor(diff / 1000);

  return {
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  };
};

export const useCountdown = (endDate: string | Dayjs | null | undefined): CountdownValue => {
  const [value, setValue] = useState<CountdownValue>(() =>
    endDate ? getDiff(dayjs(endDate)) : { days: 0, hours: 0, minutes: 0, seconds: 0 }
  );

  useEffect(() => {
    if (!endDate) {
      setValue({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      return;
    }

    const target = dayjs(endDate);
    setValue(getDiff(target));

    const id = window.setInterval(() => {
      setValue(getDiff(target));
    }, 1000);

    return () => window.clearInterval(id);
  }, [endDate?.toString()]);

  return value;
};

export const padZeros = (v: number): string => v.toString().padStart(2, '0');
